export default [
    {
      path: "/user/rating",
      name: "UserRating",
      component: () => import("@/views/Ondemand/Rating/Rating.vue"),
    },
      {
      path: "/user/delivery-summary/:id",
      name: "RatingsDeliverySummary",
      component: () => import("@/views/Ondemand/Rating/deliver-sumary.vue"),
    },
  ];